import React from 'react';
import Emulator from '../../components/emulator';

const GameSection = () => (
  <Emulator url="/roms/asap_plz.bin" />
);

export default GameSection;
